import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-grid-tile',
  templateUrl: './grid-tile.component.html',
  styleUrls: ['./grid-tile.component.scss'],
  host: {
    '[class]': 'classes',
    '[style.grid-column]': '"span " + colspan',
    '[style.grid-row]': '"span " + rowspan',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridTileComponent {
  @Input() colspan = 1;
  @Input() rowspan = 1;
  @Input() align: 'center' | 'start' | 'end' = 'center';

  get classes(): string {
    const classList: string[] = ['grid-tile'];

    if (this.align !== 'center') {
      classList.push(`grid-tile--align-${this.align}`);
    }

    return classList.join(' ');
  }
}
